import { Instance, SnapshotOut, types } from 'mobx-state-tree';

/**
 * # Etc
 *
 * Etc을 설명하세요.
 */
export const Etc = types
  .model('Etc')
  // --------------------------------------------------------------------------
  .props({
    etcSid: types.identifierNumber,
    etcContent: types.maybeNull(types.optional(types.string, '')),

    reportSid: types.optional(types.number, 0),

    insertDt: types.optional(types.number, 0),
    updateDt: types.optional(types.number, 0),
  })
  // --------------------------------------------------------------------------
  // MUTATEs ONLY! - 모델 상태를 변경
  // REQUESTs는 스토어 모델에 작성하세요.
  // ex) yarn gen model etc --store
  .actions((self) => ({
    /*
     * 여러 prop을 한번에 수정
     */
    setProps: (props: { [key: string]: IEtc }) => {
      const newProps = { ...self, ...props } as IEtc;
      (Object.keys(newProps) as TEtcKeys[]).forEach((key) => {
        // @ts-ignore
        self[key] = newProps[key];
      });
    },
  }));

// --------------------------------------------------------------------------
type TEtc = Instance<typeof Etc>;
type TEtcSnapshot = SnapshotOut<typeof Etc>;

export interface IEtc extends TEtc {}
export type TEtcKeys = keyof TEtcSnapshot & string;
export interface IEtcSnapshot extends TEtcSnapshot {}
export const createEtc = () => types.optional(Etc, { etcSid: 0 } as TEtc);
